const loginPathPart = '/sso/login?appName=is24main&sso_return=';
const logoutPathPart = '/sso/logout?appName=is24main&sso_return=';

export const INTERNAL_ROUTES = {
  BASE_PATH: '/',
  ERROR_PATH: `/error`,
  API_PATH: '' + process.env.SELF_SERVICE_API,
};

export const EXTERNAL_ROUTES = {
  ACCESS_DATA_PATH: '' + process.env.ACCESS_DATA_URL,
  DEV_PORTAL_PATH: '' + process.env.DEV_PORTAL_URL,
  SCOUT_MANAGER_PATH: '' + process.env.SCOUT_MANAGER_URL,
  SUPPORT_FEEDBACK_PATH: '' + process.env.SUPPORT_FEEDBACK_URL,
  SYSTEM_REGISTRATION_PATH: '' + process.env.SYSTEM_REGISTRATION_URL,
  LOGIN_PATH: process.env.SSO_URL + loginPathPart + process.env.SELF_SERVICE_PORTAL_URL + window.location.pathname,
  LOGOUT_PATH: process.env.SSO_URL + logoutPathPart + process.env.SELF_SERVICE_PORTAL_URL,
};
